export default "__VITE_PUBLIC_ASSET__ef01ec50__"